import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api } from "../../ConsumeApiController";

/**
 * Valida si un código de cupón es válido para el comercio actual.
 */
export async function validateRedemptionCode(code, merchant_uuid) {
    const response = await api.post(CompanyRoutes.Loyalty.REDEMPTIONS.VALIDATE, {
        code,
        merchant_uuid
    });
    return response;
}

/**
 * Ejecuta el canje final del cupón y registra el monto facturado.
 */
export async function completeRedemption(unique_code, merchant_uuid, billed_amount = null) {
    const response = await api.post(CompanyRoutes.Loyalty.REDEMPTIONS.COMPLETE, {
        unique_code,
        merchant_uuid,
        billed_amount
    });
    return response;
}